export default "__VITE_ASSET__cj3OKtg8__"